<template>
  <sliderBarDialogShell
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="beforeClose"
    @submit="confirm"
    class="add-pushRule-dialog"
  >
    <wechat-server-form
      ref="outform"
      @submit="submit"
    ></wechat-server-form>
  </sliderBarDialogShell>
</template>

<script>
import wechatServerForm from "@/components/sys/wechat-server/wechatServerForm";
import {updateWechatServer} from "@/api/sys/wechatServer/wechatServer";
import {saveWechatServer} from "../../../api/sys/wechatServer/wechatServer";

export default {
  name: "addDialog",
  components: {
    wechatServerForm,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      title: '新增服务器',
    }
  },
  methods: {
    beforeClose() {
      this.$emit('close');
      this.$refs.outform.selfClear();
    },
    cancel() {
      this.beforeClose();
    },
    confirm() {
      this.$refs.outform.selfValidate();
    },
    submit(form) {
      let params = {
        ...form,
      }
      saveWechatServer(params).then((data) => {
        if(data&&data.code&&data.code == 200){
          this.$message({
            message: '添加成功',
            type: 'success',
          });
          this.$emit('add-success');
        }else{
          this.$message.error(data.msg);
        }
      }).catch((err) => {
        // this.$message.error(err.msg);
      })
    }
  },
}
</script>

<style>
@media screen and (min-width: 768px) {
  .add-pushRule-dialog.sidebar-dialog .vs-sidebar {
    width: 800px;
  }
}
</style>
